// extracted by mini-css-extract-plugin
export default {"heroItem":"_56ae7c77","imageWrapper":"_8abbec66","image":"_24a2d9f5","title":"_7c4ceab2"};